<template>
  <b-modal id="template-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`" centered
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" @hidden="resetModal">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal" v-if="templateId === 0">{{ $t('catalog.create_template') }}</h5>
      <h5 class="modal-title adp-h2 adp-h2__modal" v-else>{{ $t('catalog.edit_template') }}</h5>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.template_name') }}</label>
        <input type="text" v-model="name" class="adp-input adp-input__text" :class="{'is-invalid': errors.name}" :placeholder="$t('catalog.name_placeholder')">
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.add_event') }}</label>
        <v-select @search="fetchNames" :placeholder="$t('catalog.event_placeholder')" label="name" v-model="tmp_event"
                  :class="{'is-invalid': errors.activities_ids}" :options="names" @input="events.push($event); tmp_event = null;">
          <template #no-options="{ search, searching }">
            <template v-if="searching">
              {{ $t('catalog.no_result_name') }} <em>{{ search }}</em>.
            </template>
            <span class="adp-p adp-p__grey" v-else>{{ $t('catalog.start_typing_for_search') }}</span>
          </template>
        </v-select>
      </div>


      <div class="adp-modal-row" v-if="events.length > 0">
        <label class="adp-p adp-p__grey">{{ $t('catalog.selected_event') }}</label>
        <b-form-checkbox v-model="event.is_selected" v-for="(event, i) in events" :key="i">
          {{ event.name }}
        </b-form-checkbox>
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" @click="save()">
        {{ $t('voc.save') }}
      </button>

      <button v-if="templateId" id="delete" class="btn btn-danger adp-btn adp-btn__red adp-btn__large" @click="deleteTemplate">
        {{ $t('voc.delete') }}
      </button>
    </template>
  </b-modal>
</template>

<script>

import api from "../../api";

export default {
  name: "TemplateModal",
  props: {
    templateId: {
      type: Number,
      default: 0,
    },
    template: {
      type: Object,
      default: 0,
    },
    selectedItems: {
      type: Object,
      default: 0,
    },
  },
  data() {
    return {
      name: '',
      names: [],
      tmp_event: null,
      events: [],
      errors: {},
    };
  },
  methods: {
    async onShow() {
      if (this.templateId < 1) {
        this.events = _.map(this.selectedItems, el => {
          return {
            personal_type:  el.personalType,
            id:             el.activityId,
            name:           el.name,
            type:           el.group,
            is_selected:    true
          };
        });

        return;
      }

      this.name = this.template.name;
      this.events = this.template.events.map(el => {
        el.is_selected = true;
        return el;
      });
    },

    resetModal() {
        this.name = '';
        this.names = [];
        this.tmp_event = null;
        this.events = [];
    },

    fetchNames(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    async search(loading, search, vm) {
      try {
        let res = await api.searchCommonEvents(search);
        this.names = res.data;
      } catch (e) {
        console.error(e);
      }
      loading(false);
    },
    deleteTemplate() {
      axios.delete('/hr/templates/' + this.templateId).then(response => {
        if (response.status === 204) {
          this.errors = [];
          this.$emit('template-created');
          this.$bvModal.hide('template-modal');
        }
      });
    },
    save() {
      let data = {
        activities_ids: [],
        name: this.name,
      };

      let activities_ids = this.events.filter(el => {
        return el.is_selected;
      });

      activities_ids = activities_ids.map(el => {
        return el.id;
      });

      data.activities_ids = activities_ids;

      axios.post('/hr/templates' + (this.templateId ? '/' + this.templateId : ''), data).then(response => {
        if (response.status === 200) {
          this.errors = [];
          this.$emit('template-created');
          this.$bvModal.hide('template-modal');
        }
      }).catch(err => {
        if(err.response.data.errors) {
          this.errors = err.response.data.errors;
        }
      });
    }
  },
}
</script>
